import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import '../../../../../BottomSheet/index.js';
import { useSelectBottomSheet } from './hooks/useSelectBottomSheet.js';
import { BottomSheet as BottomSheetMemoized } from '../../../../../BottomSheet/BottomSheet.js';

var _excluded = ["children"];
var SelectBottomSheet = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useSelectBottomSheet = useSelectBottomSheet(props),
    triggerRef = _useSelectBottomSheet.triggerRef,
    state = _useSelectBottomSheet.state,
    bottomSheetProps = _useSelectBottomSheet.bottomSheetProps;
  return triggerRef && state ? /*#__PURE__*/React.createElement(BottomSheetMemoized, bottomSheetProps, children) : null;
});

export { SelectBottomSheet };
//# sourceMappingURL=SelectBottomSheet.js.map
